import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private toastr: ToastrService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        switch (error.status) {
          case 400:
            this.toastr.error('Requête invalide.');
            break;

          case 401:
            this.toastr.error('Session expirée, veuillez vous reconnecter.');
            break;

          case 403:
            this.toastr.error('Vous n’avez pas les droits nécessaires.');
            break;

          case 404:
            this.toastr.error('Ressource introuvable.');
            break;

          case 409:
            this.toastr.error(
              error.error?.message ?? 'Conflit : cette ressource existe déjà.'
            );
            break;

          case 500:
            this.toastr.error('Erreur interne du serveur. Veuillez réessayer.');
            break;

          default:
            this.toastr.error('Une erreur inattendue est survenue.');
        }

        return throwError(() => error);
      })
    );
  }
}
